import { render, staticRenderFns } from "./Memorabilia.vue?vue&type=template&id=b72ef4f4&scoped=true"
import script from "./Memorabilia.vue?vue&type=script&lang=js"
export * from "./Memorabilia.vue?vue&type=script&lang=js"
import style0 from "./Memorabilia.vue?vue&type=style&index=0&id=b72ef4f4&prod&lang=scss"
import style1 from "./Memorabilia.vue?vue&type=style&index=1&id=b72ef4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ef4f4",
  null
  
)

export default component.exports